// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardScore_container__27jbn"};